import {
  ConfirmPrimitiveReservationInput,
  MakePrimitiveReservation
} from '../../types/cart'
import { confirmationGRPCInput } from './confirmationGRPCInput'

export function buildConfirmPrimitiveInput(
  input: ConfirmPrimitiveReservationInput,
  primitive: MakePrimitiveReservation,
  channelCode: string | undefined,
  cartID: string
): ConfirmPrimitiveReservationInput {
  return {
    ...input,
    reservationNumber: primitive.reservationNumber,
    walletID: primitive.paymentInfo.walletID,
    // A provider-credit wallet is bilateral: without the creditor the reserve runs against
    // the wallet as a whole, which holds nothing reservable, and fails as insufficient
    // funds. Take it from the reservation only, so a stale one never rides along.
    creditorID: primitive.paymentInfo.creditorID || undefined,
    cartID,
    grpcInput: confirmationGRPCInput(
      channelCode || input.grpcInput.channelCode,
      primitive.propertyCode,
      primitive.providerCode
    ),
    confirmRooms: primitive.roomStays.map((stay) => {
      const existing = input.confirmRooms.find(
        (room) => room.crsNumber === stay.crsNumber
      )
      return {
        crsNumber: stay.crsNumber,
        description: existing?.description || '',
        max: stay.occupancy.adults + stay.occupancy.extraBeds,
        profiles: existing?.profiles || [
          {
            firstName: '',
            lastName: '',
            email: '',
            identificationNo: '',
            mobile: '',
            isForeigner: false
          }
        ]
      }
    })
  }
}
